export enum CompanyTypeEnum {
  OGE = 1,
  VNB = 2,
  H2_CUSTOMER = 3,
  CO2_CUSTOMER = 4,
}
